'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecondAfter.js
// module id = 694
// module chunks = 0